import { apiAuth, apiResponseType } from ".";

export interface Transaction {
  id: number;
  description: string;
  amount: string;
  created_at: string;
  updated_at: string;
}

export interface TypeLabel {
  id: number;
  name: string;
  color: string;
}

export interface Tenant {
  id: number;
  name: string;
}

export interface DevolutionNoticeData {
  status: "approved" | "rejected";
  client_name: string;
  value: number;
  changed_by_name: string;
  observation: string | null;
}

export interface NotificationProps {
  id: number;
  uuid: string;
  code: string;
  title: string;
  message: string;
  data?: DevolutionNoticeData | null;
  reference_date: string;
  notification_type_id: number;
  notification_type_label_id: number;
  is_read: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  transactions: Transaction[];
  type_label: TypeLabel;
  tenant: Tenant;
}

// Notification type IDs
export const NOTIFICATION_TYPE = {
  FINANCIAL: 1,
  DISTRIBUTION_UNITIES: 2,
  DISTRIBUTION_SELLERS: 3,
  SALE_CHANGE_REQUEST: 4,
  DEVOLUTION_STATUS: 5,
};

export const getNotifications = (page: number = 1) => {
  return apiAuth.get(`notifications?page=${page}`) as apiResponseType;
};

export const markNotificationAsRead = (uuid: string)=> {
  return apiAuth.put(`notifications/${uuid}/update-read`) as apiResponseType;
};

export const markAllNotificationsAsRead = ()=> {
  return apiAuth.put("notifications/mark-all-read") as apiResponseType;
}; 

export const getUnreadDevolutionNotifications = () => {
  return apiAuth.get(
    `notifications?notification_type_id=${NOTIFICATION_TYPE.DEVOLUTION_STATUS}&is_read=0`
  ) as apiResponseType;
};
